"use client";

import { usePathname } from "next/navigation";

interface CanonicalLinkProps {
  baseUrl: string;
}

const CanonicalLink = ({ baseUrl }: CanonicalLinkProps) => {
  const pathname = usePathname();
  const canonicalPath = pathname === "/" ? "" : pathname;
  const canonicalDomain = baseUrl.replace(/^https?:\/\/(www\.)?/, "https://");
  const canonicalUrl = `${canonicalDomain}${canonicalPath}`;

  return <link href={canonicalUrl} rel="canonical" />;
};

export default CanonicalLink;
